import { render, staticRenderFns } from "./modal-import-express-file.vue?vue&type=template&id=205b2e52&scoped=true"
import script from "./modal-import-express-file.vue?vue&type=script&lang=js"
export * from "./modal-import-express-file.vue?vue&type=script&lang=js"
import style0 from "./modal-import-express-file.vue?vue&type=style&index=0&id=205b2e52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b2e52",
  null
  
)

export default component.exports